<div class="search-item">
  @switch (!!link()) {
    @case (true) {
      <a class="item-header" [routerLink]="link()">
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </a>
    }
    @case (false) {
      <button class="btn-unstyled item-header" (click)="clicked.emit()">
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
      </button>
    }
  }

  <ng-template #itemContent>
    <span class="item-icon" [class]="'icon-' + icon()"></span>
    <div class="item-details">
      <div class="item-title">
        {{ title() | translate }}
        @if (countryFlagLinks()?.length) {
          -
          @for (country of countryFlagLinks(); track country) {
            <img class="country-flag" [src]="country.flagUrl" />
          }
        }
      </div>
      @if (subtitle()) {
        <div class="item-subtitle">{{ subtitle() | translate }}</div>
      }
    </div>
    <span class="icon-btn btn-unstyled" [class]="'icon-chevron-' + chevron()"></span>
  </ng-template>
  <ng-content slot="content"></ng-content>
</div>
